import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
import axiosInstance from "../../../../../../Utils/axios";

let cancelToken;

const saleCreditNoteURL = `api/v1/sales-app/dr-cr-notes`;

//obtaining the paginated data
export const getSaleCreditNote = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleCreditNoteURL}/list?note_type=sales_credit&${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllSaleCreditNote = () => axiosInstance.get(`${saleCreditNoteURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageSaleCreditNote = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${saleCreditNoteURL}/list?note_type=sales_credit&${paginationQueryParams(rowsPerPage, search, "", number)}`
  );

export const getSaleCreditNoteAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?is_active=true`);

// get by id
export const getSaleCreditNoteById = (id) => axiosInstance.get(`${saleCreditNoteURL}/retrieve/${id}`);

// fetch sale invoice details
export const getSaleCreditNoteDetailsById = (id) => axiosInstance.get(`api/v1/sales-app/sales-invoice/retrieve/${id}`);
//creating function
export const createSaleCreditNote = (body) => axiosInstance.post(`${saleCreditNoteURL}/create`, body);
//updating function
export const updateSaleCreditNote = (id, body) => axiosInstance.patch(`${saleCreditNoteURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleCreditNoteURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}&note_type=sales_credit`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
